import { render, staticRenderFns } from "./protectionismB.vue?vue&type=template&id=c9ec130e"
import script from "./protectionismB.vue?vue&type=script&lang=js"
export * from "./protectionismB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports